import { useSelector } from 'react-redux';

import cx from 'classnames';
import { isEmpty } from 'lodash';
import { hasTeamMembers } from 'selectors/professionals';
import { getSelectedServices } from 'selectors/services';

import { Button } from '../Button/Button';

import s1 from '../PlayfulLayout.module.css';
import s from './CtaBookNow.module.css';

export const CtaBookNow = () => {
  const isMultiUser = useSelector(hasTeamMembers);
  const selectedServices = useSelector(getSelectedServices);

  const bookNowLinkUrl =
    isMultiUser && isEmpty(selectedServices) ? '/booking-flow' : '/services';

  return (
    <div className={cx(s.bookNow, s1.full)}>
      <div className={s.container}>
        {[...Array(3)].map((_, index) => (
          <Button
            to={bookNowLinkUrl}
            wrapArrow
            key={index}
            className={s.item}
            arrowClassName={s.arrow}
            ariaHidden={index > 0}
          >
            book now
          </Button>
        ))}
      </div>
      <div className={s.container} aria-hidden="true">
        {[...Array(3)].map((_, index) => (
          <Button
            to={bookNowLinkUrl}
            wrapArrow
            key={index}
            className={s.item}
            arrowClassName={s.arrow}
          >
            book now
          </Button>
        ))}
      </div>
    </div>
  );
};
